import { cn } from "@/lib/utils";
import type { SkillKey } from "../types";
import { useLanguage } from "../i18n";

export interface SkillCheckboxProps {
  skill: SkillKey;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

export function SkillCheckbox({ skill, checked, onChange, className }: SkillCheckboxProps) {
  const { t } = useLanguage();
  const skillLabel = t.skills[skill];

  return (
    <label
      className={cn(
        "flex items-center gap-2 cursor-pointer select-none",
        "text-sm px-3 py-1.5 transition-all",
        "bg-bb-gray-mid border border-bb-gray-mid",
        "hover:border-bb-blood-red",
        checked && "border-bb-gold bg-bb-gold/20",
        className
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-3.5 w-3.5 cursor-pointer accent-bb-gold"
      />
      <span className="text-bb-bone-white">{skillLabel}</span>
    </label>
  );
}
